import classNames from "classnames"

import { ComponentPropsWithout, RemovedProps } from "../component-props"
import { FontWeightProps } from "../props/weight.props"

import "./text.css"

const TEXT_NAME = "SuiText"

const textSizes = ["extra-large", "large", "regular", "small", "extra-small"]

type TextSize = (typeof textSizes)[number]

interface CommonTextProps extends FontWeightProps {
  size?: TextSize
}

type TextSpanProps = { as?: "span" } & ComponentPropsWithout<
  "span",
  RemovedProps
>
type TextDivProps = { as: "div" } & ComponentPropsWithout<"div", RemovedProps>
// type TextLabelProps = { as: "label" } & ComponentPropsWithout<
//   "label",
//   RemovedProps
// >
type TextPProps = { as: "p" } & ComponentPropsWithout<"p", RemovedProps>
type TextProps = CommonTextProps & (TextSpanProps | TextDivProps | TextPProps)

const Text = ({
  children,
  className,
  as: Tag = "span",
  size = "regular",
  weight,
  ...textProps
}: TextProps) => {
  return (
    <Tag
      className={classNames(
        TEXT_NAME,
        size ? `size-${size}` : undefined,
        weight ? `sui-font-weight-${weight}` : undefined,
        className
      )}
      sx={{
        fontSize: "var(--font-size, var(--sui-font-size-default))",
        lineHeight: "var(--line-height, var(--sui-line-height-default))",
      }}
      {...textProps}
    >
      {children}
    </Tag>
  )
}
Text.displayName = TEXT_NAME

export { Text, textSizes }
export type { TextProps }
